import { render, staticRenderFns } from "./ReferralsNewResults.vue?vue&type=template&id=94d6353a"
import script from "./ReferralsNewResults.vue?vue&type=script&lang=js"
export * from "./ReferralsNewResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports